var map = {
	"./celebration-final.svg": 1384,
	"./celebration.svg": 1385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1383;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/celebration.*\.svg$
// module id = 1383
// module chunks = 0